export enum LabelNameEnum {
  deals = 'Deals',
  orgs = 'Organizations',
  projects = 'Projects',
  // Backend canonical label name is 'Contact' (see SiteSetting::getAppLabels) —
  // isGCLabelActive matches by exact name. 'contacts' is left as-is because it
  // gates the whole Sales dropdown in DashboardNavbar, which must not hide
  // when the Contact module is toggled off.
  people = 'Contact',
  contacts = 'Contacts',
  proposals = 'Proposals',
  support = 'Support',
  orders = 'Orders',
  subs = 'Subscriptions',
  reports = 'Reports',
  timeMaterial = 'Time & Materials',
  'tools' = 'Tools',
  'presentations' = 'Presentations',
  fees = 'Fees',
  finance = 'Finance',
}
export interface CompactLabelResponse {
  name: string;
  value: string;
  status: boolean;
}

export interface LabelResponse {
  labels: CompactLabelResponse[];
}
